import { gsap } from 'gsap';
import { DrawSVGPlugin } from 'gsap/DrawSVGPlugin.js';
import { CustomEase } from 'gsap/CustomEase.js';


class CirclesAnimation {

    constructor() {

      if ($('.section-circles-svg')[0]) {

        gsap.registerPlugin(DrawSVGPlugin, CustomEase);

        console.log('IntroAnimation')

        //gsap.set(myPath, { scaleX: -1, transformOrigin: "center center" });

        /*gsap.set('.st0', {drawSVG: '-100% 100%'})
        gsap.set('.st1', {drawSVG: '-100% 100%'})
        gsap.set('.st2', {drawSVG: '-100% 100%'})
        gsap.set('.st3', {drawSVG: '-100% 100%'})
        gsap.set('.st4', {drawSVG: '-100% 100%'})
        gsap.set('.st5', {drawSVG: '-100% 100%'})
        gsap.set('.st6', {drawSVG: '-100% 100%'})
        gsap.set('.st7', {drawSVG: '-100% 100%'})
        gsap.set('.st8', {drawSVG: '-100% 100%'})
        gsap.set('.st9', {drawSVG: '-100% 100%'})
        gsap.set('.st10', {drawSVG: '-100% 100%'})
        gsap.set('.st11', {drawSVG: '-100% 100%'})
        gsap.set('.st12', {drawSVG: '-100% 100%'})
        gsap.set('.st13', {drawSVG: '-100% 100%'})
        gsap.set('.st14', {drawSVG: '-100% 100%'})
        gsap.set('.st15', {drawSVG: '-100% 100%'})
        gsap.set('.st16', {drawSVG: '-100% 100%'})
        gsap.set('.st17', {drawSVG: '-100% 100%'})
        gsap.set('.st18', {drawSVG: '-100% 100%'})*/

        gsap.set('.st0', {drawSVG: '-100% 0%'})
        gsap.set('.st1', {drawSVG: '-100% 0%'})
        gsap.set('.st2', {drawSVG: '-100% 0%'})
        gsap.set('.st3', {drawSVG: '-100% 0%'})
        gsap.set('.st4', {drawSVG: '-100% 0%'})
        gsap.set('.st5', {drawSVG: '-100% 0%'})
        gsap.set('.st6', {drawSVG: '-100% 0%'})
        gsap.set('.st7', {drawSVG: '-100% 0%'})
        gsap.set('.st8', {drawSVG: '-100% 0%'})
        gsap.set('.st9', {drawSVG: '-100% 0%'})
        gsap.set('.st10', {drawSVG: '-100% 0%'})
        gsap.set('.st11', {drawSVG: '-100% 0%'})
        gsap.set('.st12', {drawSVG: '-100% 0%'})
        gsap.set('.st13', {drawSVG: '-100% 0%'})
        gsap.set('.st14', {drawSVG: '-100% 0%'})
        gsap.set('.st15', {drawSVG: '-100% 0%'})
        gsap.set('.st16', {drawSVG: '-100% 0%'})
        gsap.set('.st17', {drawSVG: '-100% 0%'})
        gsap.set('.st18', {drawSVG: '-100% 0%'})

        gsap.set('.header-inner', {opacity: 0})




        //gsap.set('.logo-wrapper', {opacity: 0})

        //gsap.set('#link-1', {opacity: 0})
        //gsap.set('#link-2', {opacity: 0})
        //gsap.set('#link-3', {opacity: 0})
        // gsap.set('#link-4', {opacity: 0})

        let tl = gsap.timeline();

        let duration = 0.5;
        let offset = '-=0.25';
        let ease = 'power4.inOut'

        tl
          .to('.st0', {drawSVG: '100%', duration: duration,  ease: ease})
          .to('.st1', {drawSVG: '100%', duration: duration,  ease: ease}, offset)
          .to('.st2', {drawSVG: '100%', duration: duration,  ease: ease}, offset)
          .to('.st3', {drawSVG: '100%', duration: duration,  ease: ease}, offset)
          .to('.st4', {drawSVG: '100%', duration: duration,  ease: ease}, offset)
          .to('.st5', {drawSVG: '100%', duration: duration,  ease: ease}, offset)
          .to('.st6', {drawSVG: '100%', duration: duration,  ease: ease}, offset)
          .to('.st7', {drawSVG: '100%', duration: duration,  ease: ease}, offset)
          .to('.st8', {drawSVG: '100%', duration: duration,  ease: ease}, offset)
          .to('.st9', {drawSVG: '100%', duration: duration,  ease: ease}, offset)
          .to('.st10', {drawSVG: '100%', duration: duration,  ease: ease}, offset)
          .to('.st11', {drawSVG: '100%', duration: duration,  ease: ease}, offset)
          .to('.st12', {drawSVG: '100%', duration: duration,  ease: ease}, offset)
          .to('.st13', {drawSVG: '100%', duration: duration,  ease: ease}, offset)
          .to('.st14', {drawSVG: '100%', duration: duration,  ease: ease}, offset)
          .to('.st15', {drawSVG: '100%', duration: duration,  ease: ease}, offset)
          .to('.st16', {drawSVG: '100%', duration: duration,  ease: ease}, offset)
          .to('.st17', {drawSVG: '100%', duration: duration,  ease: ease}, offset)
          .to('.st18', {drawSVG: '100%', duration: duration,  ease: ease}, offset)
          .to('.header-inner', {opacity: 1, duration: 3}, '-=3')

        //.to('.logo-wrapper',  {opacity: 1, delay:0.5, duration: 2})
        //.to('#link-1',  {opacity: 1, delay:0.5, duration: 0.75})
        //.to('#link-2',  {opacity: 1, duration: 0.75}, "-=0.25")
        //.to('#link-3',  {opacity: 1, duration: 0.75},"-=0.25")
        //.to('#link-4',  {opacity: 1, duration: 0.75},"-=0.25")
        ;

      }
    }
}

export default CirclesAnimation



// WEBPACK FOOTER //
// ./scripts/util/circlesAnim.js